/*
* profielkeuze.ts
* 10-10-2024 - Jelmer Jellema - Spin in het Web B.V.
*
* Profielkeuze-model
*/

import {Basemodel, ModelField} from "./basemodel";

export class Profielkeuze extends Basemodel {
  @ModelField() override id: number;
  @ModelField() profielkeuze: string;
  @ModelField() opmerking: string = null;
  @ModelField() studierichting_id: number;
}

